import React from "react";
import "./cockpit.css";

/**
 * The Pokédex screen assembly.
 *
 * Wraps the chart in the device's front plate: a grey bezel with the
 * characteristic notched bottom-left corner, two indicator lamps above the
 * display, and the red button + vent bars below it. The chart itself is the
 * screen set into the plate.
 *
 * The notch is PAINTED as an overlay on the casing, not cut with `clip-path`:
 * a clip applies to the whole subtree, which sliced off the chart's timeframe
 * dropdown whenever it opened.
 *
 * Marked `ce-raw`, which exempts the whole subtree from the theme sweeps (they
 * are guarded with `:not(.ce-raw *)`). That keeps the plate's parts and the
 * chart card inside it free of the Panel treatment, so the plate is the only
 * frame. Known trade-off: the chart's timeframe control keeps its original
 * purple, since the purple→red sweep is exempted along with everything else.
 *
 * @param {{children: React.ReactNode}} props
 */
export function ScreenFrame({ children }) {
  return (
    <div className="ce-raw ce-screen-casing">
      <div className="ce-screen-face">
        {/* Indicator lamps, above the display like the reference. */}
        <div className="ce-screen-lamps" aria-hidden="true">
          <span className="ce-screen-lamp" />
          <span className="ce-screen-lamp" />
        </div>

        {/* The display. */}
        <div className="ce-screen-inner">{children}</div>

        {/* Button + vent (spec §6: 4–5 stacked bars, lower-right). */}
        <div className="ce-screen-footer" aria-hidden="true">
          <span className="ce-screen-button" />
          <span className="ce-screen-vent">
            <i />
            <i />
            <i />
            <i />
          </span>
        </div>
      </div>
    </div>
  );
}

export default ScreenFrame;
